<template>
  <div>
    <newsbanner></newsbanner>
    <div class="detail">
      <newsDetail :params="selectedNews || {}"></newsDetail>
    </div>
    <div class="nav-buttons">
    <el-row :gutter="20">
      <el-col :span="12">
        <button  v-if="showPreviousBtn" @click="getNextNews">上一篇</button>
      </el-col>
      <el-col :span="12">
        <button v-if="showNextBtn" @click="getPreviousNews">下一篇</button>
      </el-col>
    </el-row>
  </div>
  </div>
</template>

<script>
import newsbanner from "@/components/contentcoms/newscontentcoms/newsbanner";
import newsDetail from "@/components/Common/newsDetail.vue";
import { getAllNews, getAdjacentNews } from "@/api/news/newsInfo.js";
export default {
  data() {
    return {
      listNews: {
        id: 1,
        newsTitle: "",
        pageNum: 1,
        pageSize: 10
      },
      row: "",
      selectedNews: "",
      currentNewsId: "",
      direction: null,
      showPreviousBtn: true, // 控制上一篇按钮的显示
      showNextBtn: true,  
    };
  },
  name: "newscontents",
  components: {
    newsbanner,
    newsDetail
  },
  created() {
    console.log(this.$route.query.row)
    // 如果传递整条新闻
    if (this.$route.query.row) {
      if (this.$route.query.row.id != undefined) {
     
        this.handledetailBtn(this.$route.query.row);
        this.currentNewsId = this.$route.query.row.id; //给当前新闻id赋值
      } else {
        this.$router.replace({ path: "/news" });
      }
    } else if (this.$route.query.id) {
      this.currentNewsId = this.$route.query.id;
      this.fetchNews(this.currentNewsId);
    }
  },
  methods: {
    fetchNews() {
      getAllNews(this.listNews).then(res => {
        console.log(777)
        let row = res.data.records[0];
        row.newsContent = this.addPrefixToImg(row.newsContent, base_url_src);
        console.log(row.newsContent)
        console.log(base_url_src)

        this.selectedNews = row;
      });
    },
    getPreviousNews() {
  const parms = {
    currentId: this.currentNewsId,
    direction: "prev"
  };
  getAdjacentNews(parms).then(response => {
    if (response.status === 0) {
      if (response.data === "这是最后一篇新闻") {
        alert("这是最后一篇新闻");
        this.showNextBtn = false;
      } else {
        this.currentNewsId = response.data.id;
        this.selectedNews = response.data;
        this.selectedNews.newsContent = this.addPrefixToImg(this.selectedNews.newsContent, base_url_src);
        this.showPreviousBtn = true;
      }
    } else {
      console.error("请求失败:", response.data.message);
    }
  }).catch(error => {
    console.error("请求失败:", error);
  });
},

getNextNews() {
  const parms = {
    currentId: this.currentNewsId,
    direction: "next"
  };
  getAdjacentNews(parms).then(response => {
    console.log(response)
    if (response.status === 0) { 
      if (response.data=== "这是第一篇新闻") {
        alert("这是第一篇新闻");
        this.showPreviousBtn = false;
      } else {
        this.currentNewsId = response.data.id;
        this.selectedNews = response.data;
        this.selectedNews.newsContent = this.addPrefixToImg(this.selectedNews.newsContent, base_url_src);
        this.showNextBtn = true;
      }
    } else {
      console.error("请求失败:", response.data.message);
    }
  }).catch(error => {
    console.error("请求失败:", error);
  });
},
    handledetailBtn(row) {
     
      this.selectedNews = row;
      this.selectedNews.newsContent = this.addPrefixToImg(this.selectedNews.newsContent, base_url_src);
    },

    addPrefixToImg(html, prefix) {
      if (html == null) return;
      const regexp = /<img[^>]+src="([^">]+)"/g;
      const modifiedHtml = html.replace(regexp, (match, src) => {
        if (!src.startsWith(prefix)) {
          return match.replace(src, `${prefix}${src}`);
        }

        return match;
      });
      return modifiedHtml;
    }
  }
};
</script>
  
  <style scoped>
.detail {
  margin-left: 20%;
  margin-right: 20%;
}
.nav-buttons{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/newscontentcoms/newscontent.vue